import { useState, useEffect } from 'react';
import Button from '../Button';

interface JobItemProps {
  title: string;
  location: string;
  isActive: boolean;
  jobId?: number;
  onJobClick: () => void;
  onActionClick?: (jobId?: number) => void;
  actionButtonText: string;
  actionButtonVariant: 'outline-primary' | 'outline-danger' | 'transparent';
  isMockJob?: boolean;
}

const JobItem = ({ 
  title, 
  location, 
  isActive, 
  jobId,
  onJobClick, 
  onActionClick, 
  actionButtonText,
  actionButtonVariant,
  isMockJob = false
}: JobItemProps) => {
  // Track window width for responsive behavior
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768; // Standard breakpoint for mobile

  // Update window width when it changes
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handler for action button click that passes the jobId
  const handleActionClick = () => {
    if (onActionClick) {
      onActionClick(jobId);
    }
  };

  return (
    <div style={{ 
      padding: isMobile ? '0.75rem' : '1rem',
      borderRadius: '4px',
      border: isMockJob ? '2px dashed #4caf50' : '1px solid #e9ecef',
      backgroundColor: isMockJob ? 'rgba(76, 175, 80, 0.05)' : 'transparent',
    }}>
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: '0.75rem'
      }}>
        <div style={{ width: '100%' }}>
          <a 
            href="#" 
            style={{ 
              margin: 0,
              color: '#0d6efd',
              textDecoration: 'underline',
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              fontWeight: 500,
              display: 'block',
              wordBreak: 'break-word'
            }}
            onClick={(e) => {
              e.preventDefault();
              onJobClick();
            }}
          >
            {isMockJob ? `🧪 ${title} (TEST)` : (title || 'No job title')}
          </a>
          <p style={{ margin: '0.25rem 0 0 0', fontWeight: 500 }}>{location.includes("null") ? "No location" : location}</p>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'row',
          alignItems: 'center',
          justifyContent: isMobile ? 'space-between' : 'flex-end',
          gap: isMobile ? '0.5rem' : '1rem',
          width: isMobile ? '100%' : 'auto',
          marginTop: isMobile ? '0.5rem' : 0
        }}>
          {/* <span style={{ 
            backgroundColor: isActive ? '#20c997' : '#6c757d',
            color: 'white',
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            fontSize: '0.875rem',
            whiteSpace: 'nowrap'
          }}>
            {isActive ? 'Active' : 'Inactive'}
          </span> */}
          <Button
            text={actionButtonText}
            variant={actionButtonVariant}
            onClick={handleActionClick}
            id={`job-item-${actionButtonText}-button-${jobId}`}
          />
        </div>
      </div>
    </div>
  );
};

export default JobItem; 